import { cUtil } from "../../functions/util";


export class cAdminAdsItem {

  fieldset      = document.createElement('fieldset');
  button_add    = document.createElement('button');
  button_del    = document.createElement('button');
  label_status  = document.createElement('label');
  input_status  = document.createElement('input');
  input_urlDe   = document.createElement('input'); 
  input_urlFr   = document.createElement('input');
  input_titleDe = document.createElement('input');
  input_titleFr = document.createElement('input'); 
  label_urlDe   = document.createElement('label'); 
  label_urlFr   = document.createElement('label');
  label_titleDe = document.createElement('label');
  label_titleFr = document.createElement('label'); 
  input_data    = document.createElement('input');
  div_img       = document.createElement('div');
  img           = document.createElement('img');
  label_css     = document.createElement('label');
  select_css    = document.createElement('select');
  option_none   = document.createElement('option');
  option_small  = document.createElement('option');
  option_full   = document.createElement('option');

  mediaFrame : any;
  inputData  : AdsItemData;

  constructor(parent: HTMLElement, item: AdsItemData) {

    this.inputData = item;

    // ---- structure ----
    parent.append(this.fieldset);
      this.fieldset.append(this.div_img);
        this.div_img.append(this.img);
      this.fieldset.append(this.label_status);
      this.fieldset.append(this.input_status);
      this.fieldset.append(this.button_add);
      this.fieldset.append(this.button_del);
      this.fieldset.append(this.label_urlDe);
      this.fieldset.append(this.input_urlDe);
      this.fieldset.append(this.label_urlFr);
      this.fieldset.append(this.input_urlFr);
      this.fieldset.append(this.label_titleDe);
      this.fieldset.append(this.input_titleDe);
      this.fieldset.append(this.label_titleFr);
      this.fieldset.append(this.input_titleFr);
      this.fieldset.append(this.label_css);
      this.fieldset.append(this.select_css);
        this.select_css.append(this.option_small);
        this.select_css.append(this.option_none);
        this.select_css.append(this.option_full);
      this.fieldset.append(this.input_data);

    // ---- Label Ids ----
    cUtil.labelIds(this.label_status  , this.input_status);
    cUtil.labelIds(this.label_urlDe   , this.input_urlDe);
    cUtil.labelIds(this.label_urlFr   , this.input_urlFr);
    cUtil.labelIds(this.label_titleDe , this.input_titleDe);
    cUtil.labelIds(this.label_titleFr , this.input_titleFr);
    cUtil.labelIds(this.label_css     , this.select_css);

    // ---- Texts ----
    this.button_add    .innerText = 'Bild hinzufügen';
    this.button_del    .innerText = 'Bild löschen';
    this.label_urlDe   .innerText = 'Link (De)';
    this.label_urlFr   .innerText = 'Link (Fr)';
    this.label_titleDe .innerText = 'Text (De)';
    this.label_titleFr .innerText = 'Text (Fr)';
    this.label_status  .innerText = 'Aktiv';
    this.label_css     .innerText = 'Design';
    this.option_small  .innerText = 'Kleines Bild';
    this.option_full   .innerText = 'Grosses Bild';
    this.option_none   .innerText = 'Kein Bild';

    // ---- Classes & grid-area -----
    this.css('div_img');
    this.css('button_add');
    this.css('button_del');
    this.css('label_status');
    this.css('input_status');
    this.css('label_urlDe');
    this.css('input_urlDe');
    this.css('label_urlFr');
    this.css('input_urlFr');
    this.css('label_titleDe');
    this.css('input_titleDe');
    this.css('label_titleFr');
    this.css('input_titleFr');
    this.css('input_data');
    this.css('label_css');
    this.css('select_css');

    // ---- Ohter ----
    this.button_add   .type  = 'button';
    this.button_del   .type  = 'button';
    this.input_status .type  = 'checkbox';
    this.option_full  .value = 'c-full-image';
    this.option_none  .value = 'c-no-image';
    this.option_small .value = ''; 

    // ---- Init ---
    this.input_data.value     = item.image_id;
    this.img.src              = item.image;
    this.input_urlDe.value    = item.url_de;
    this.input_urlFr.value    = item.url_fr;
    this.input_titleDe.value  = item.title_de;
    this.input_titleFr.value  = item.title_fr;
    this.input_status.checked = item.status === 'true';

    if (item.css === 'c-full-image') {
      this.option_full.selected = true;
    }
    if (item.css === 'c-no-image') {
      this.option_none.selected = true;
    }
    if (item.css === '') {
      this.option_small.selected = true;
    }

    if (item.image === '') {
      this.img.classList.add('c-hidden');
    }

    // ---- Events ----
    this.button_add.addEventListener('click', (e) => {
      e.preventDefault();

      this.mediaFrame = wp.media({
        title    : 'Select Media',
        multiple : false,
        library  : {
          type   : 'image',
        }
      });
      this.mediaFrame.open();

      this.mediaFrame.on('select', () => {
        const attachment = 
          this.mediaFrame
          .state()
          .get('selection')
          .first()
          .toJSON();

        this.img.src = attachment.url;
        this.img.classList.remove('c-hidden');
      
        this.input_data.value = attachment.id;
      });
    });

    this.button_del.addEventListener('click', (e) => {
      this.img.classList.add('c-hidden');
      this.input_data.value  = '0';
    });
  }

  getData(): AdsItemData {
    this.inputData.image    = '';
    this.inputData.image_id = this.input_data    .value;
    this.inputData.title_de = this.input_titleDe .value;
    this.inputData.title_fr = this.input_titleFr .value;
    this.inputData.url_de   = this.input_urlDe   .value;
    this.inputData.url_fr   = this.input_urlFr   .value;
    this.inputData.css      = this.select_css    .value;
    this.inputData.status   = String(this.input_status.checked);
    return this.inputData;
  }

  css<K extends keyof cAdminAdsItem>(propertyName: K): void {
    const property = this[propertyName];
    if (! (property instanceof HTMLElement)) return;
    property.classList.add(propertyName);
    property.style.gridArea = propertyName;
  }
}